import type { FlightCardData } from '@massilia/queries'

import { Button, FullScreenOverlay } from '@massilia/ui'
import { useState } from 'react'

import { useFiltersState } from './filters-state-context'
import { FlightFilters } from './flight-filters'

interface FiltersModalProps {
  isOpen: boolean
  offers: FlightCardData[]
  onClose: () => void
}

export function FiltersModal({ isOpen, offers, onClose }: FiltersModalProps) {
  const { filters, setFilters } = useFiltersState()
  const [localFilters, setLocalFilters] = useState(filters)

  // Réinitialise le brouillon sur les filtres actifs à chaque ouverture — pas
  // d'effect : on ajuste l'état pendant le rendu (cf. doc React) pour éviter un
  // rendu « périmé » avant que l'effect ne s'exécute.
  const [wasOpen, setWasOpen] = useState(isOpen)
  if (isOpen !== wasOpen) {
    setWasOpen(isOpen)
    if (isOpen) {
      setLocalFilters(filters)
    }
  }

  return (
    <FullScreenOverlay
      footer={
        <Button
          className="w-full bg-brand-600 hover:bg-brand-700"
          onClick={() => {
            setFilters(localFilters)
            onClose()
          }}
        >
          Appliquer
        </Button>
      }
      onOpenChange={(open) => {
        if (!open) onClose()
      }}
      open={isOpen}
      title="Filtres"
    >
      <div className="px-4 py-4">
        <FlightFilters offers={offers} />
      </div>
    </FullScreenOverlay>
  )
}
